import React, { useEffect } from 'react';
import './ShowEventDataModal.scss';
import { inject, observer } from 'mobx-react';
import { ModalStore, MODALTYPE } from 'stores/private/ModalStore';
import ReactJson from 'react-json-view';
import PageContainer from 'components/PageContainer/PageContainer';
import { PageHeadLine } from 'components/PageHeadLine/PageHeadLine';
import PageContent from 'components/PageContent/PageContent';
import { ampli } from 'ampli';
import { Title } from 'components/Title/Title';

interface ShowEventDataModalProps {
  modalStore?: ModalStore;
}

const ShowEventDataModal = ({ modalStore }: ShowEventDataModalProps) => {
  useEffect(() => {
    ampli.contactEventsViewed();
  }, []);

  const customData = modalStore?.getCustomData(MODALTYPE.SHOW_EVENT_DATA);

  return (
    <div className="show-event-container">
      <Title label="Event details" className="mb-30" />
      <ReactJson
        theme={
          localStorage.getItem('theme') === 'dark'
            ? 'brewer'
            : 'shapeshifter:inverted'
        }
        src={{
          name: customData?.name,
          data: customData?.data,
        }}
        style={{
          background: 'transparent',
        }}
      />
    </div>
  );
};

export default inject('modalStore')(observer(ShowEventDataModal));
